import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";
import SharedDocsTab from "../../../../Common_Component/SharedDocsTab";
import AppContext from "../../DocsFunding/ContextCreation/AppContext";
import Amendments from "../Amendments";
import Cancel from "../Cancel";
import FranchiseInfo from "../FranchiseInfo";
import Notes from "../Notes";
import Rfis from "../Rfis";
import Summary from "../Summary_details";

const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#3f51b5",
		color: "white",
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [guarantorData, setGuarantorData] = useState([]);

	const handleClose = (event) => {
		if (props.callback) {
			props.callback(event);
		} else {
			setOpen(false);
		}
	};

	useEffect(() => {
		const handleBackButton = () => {
			if (open) {
				handleClose(); // Close the dialog if it's open
			}
		};
		window.addEventListener("popstate", handleBackButton);
		return () => {
			window.removeEventListener("popstate", handleBackButton);
		};
	}, [open]);

	useEffect(() => {
		if (props.mode === "show") {
			setOpen(true);
		} else {
			setOpen(false);
		}
	}, [props.mode]);

	return (
		<div>
			<Dialog
				fullScreen={props.fullScreen}
				open={open}
				onClose={handleClose}
				TransitionComponent={Transition}
				maxWidth="lg">
				<AppBar className={classes.appBar}>
					<Toolbar>
						<Typography variant="h6" className={classes.title} align="center">
							{props.title} - {props.app.id} - {props.app.record_type}
						</Typography>
						<IconButton
							edge="start"
							color="inherit"
							onClick={handleClose}
							aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				{(() => {
					switch (props.name) {
						case "docs":
							// Docs MFE: appType from host (getAppType()) so remote knows queue context.
							return (
								<SharedDocsTab
									app={props.app}
									isReadOnly={props.isReadOnly}
									appType={props.appType}
								/>
							);
						case "franchise_info":
							return <FranchiseInfo app={props.app} />;
						case "notes":
							return <Notes app={props.app} />;
						case "cancel":
							return <Cancel app={props.app} handleClose={handleClose} />;
						case "rfi":
							return (
								<Rfis
									app={props.app}
									rfiList={props.rfiList}
									loadRfis={props.loadRfis}
								/>
							);
						case "amendments":
							return (
								<Amendments
									app={props.app}
									isReadOnly={props.isReadOnly}
									onParentModalClose={handleClose}
								/>
							);
						default:
							return (
								<AppContext.Provider
									value={{
										setGuarantorData,
									}}>
									<Summary app={props.app} isReadOnly={true} />
								</AppContext.Provider>
							);
					}
				})()}
			</Dialog>
		</div>
	);
}

export default FullScreenDialog;
